import EnTableColumnSetting from "./src/index";

EnTableColumnSetting.install = function(Vue) {
  Vue.component(EnTableColumnSetting.name, EnTableColumnSetting);
};

export const ColumnSetting = EnTableColumnSetting;
export default EnTableColumnSetting;
